angular.module('app.directives.schedule').directive('recurrencePattern', () => {
  return {
    restrict: 'E',
    template: require('./recurrence-pattern.html'),
  };
});



// WEBPACK FOOTER //
// ./app/directives/schedule/recurrence-pattern.js